export function getBasketballStatisticHeader(light?: boolean) {
  return [
    {
      id: 'gamesCount',
      title: 'Матчи'
    },
    {
      id: 'wonGamesCount',
      title: 'Победы',
    },
    {
      id: 'points',
      title: 'Очки'
    },
    ...(!light
        ? [
          {
            id: 'rebounds',
            title: 'Подборы'
          },
          {
            id: 'assists',
            title: 'Передачи'
          },
          {
            id: 'blocks',
            title: 'Блокшоты'
          },
          {
            id: 'steals',
            title: 'Перехваты'
          },
          {
            id: 'turnovers',
            title: 'Потери'
          },
        ]
        : []
    ),
    {
      id: 'twoPointsMade',
      title: '2 очковые'
    },
    {
      id: 'twoPointPercent',
      title: '% 2 очковых'
    },
    {
      id: 'threePointsMade',
      title: '3 очковые'
    },
    {
      id: 'threePointPercent',
      title: '% 3 очковых'
    },
    {
      id: 'freeThrowsMade',
      title: 'штрафных'
    },
    {
      id: 'freeThrowPercent',
      title: '% штрафных'
    },
    {
      id: 'gameMinutes',
      title: 'Игровоое время (мин)'
    }
  ];
}
